// Shared API helpers used by all pages.

const parseApiResponse = async (res) => {
  if (!res.ok) {
    const text = await res.text();
    try {
      const data = JSON.parse(text);
      throw new Error(data.error || text);
    } catch (error) {
      if (error instanceof SyntaxError) throw new Error(text);
      throw error;
    }
  }
  return res.json();
};

export const api = {
  async get(url) {
    const res = await fetch(url);
    return parseApiResponse(res);
  },
  async post(url, data) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return parseApiResponse(res);
  },
  async patch(url, data) {
    const res = await fetch(url, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return parseApiResponse(res);
  },
  async delete(url) {
    const res = await fetch(url, { method: 'DELETE' });
    return parseApiResponse(res);
  },
};
